import React, { createContext, useContext, useMemo } from "react";

export type TurnstileConfig = {
  isTurnstileEnabled: boolean;
  isTurnstileExperimentEnabled: boolean;
  isAutomationEnabled: boolean;
  isEmulateBot: boolean;
  titleText: string;
  descriptionText: string;
  ctaButtonOneText: string;
};

export type AppConfig = {
  turnstile: TurnstileConfig;
};

export type ApplicationContextType = {
  applicationName: string;
  turnstile: TurnstileConfig | null;
};

const ApplicationContext = createContext<ApplicationContextType>({
  applicationName: "",
  turnstile: null,
});

export const useApplication = () => useContext(ApplicationContext);

function ApplicationContextProvider({
  children,
  appConfig,
}: Readonly<{
  children: React.ReactNode;
  appConfig?: AppConfig | null;
}>) {
  const applicationName = process.env.NEXT_PUBLIC_APPLICATION ?? "quote";
  const value = useMemo(
    () => ({
      applicationName,
      turnstile: appConfig?.turnstile ?? null,
    }),
    [applicationName, appConfig]
  );

  return (
    <ApplicationContext.Provider value={value}>
      {children}
    </ApplicationContext.Provider>
  );
}

export default ApplicationContextProvider;
